import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { IoMdClose } from "react-icons/io";
import InformasiResultPopup from "../../../SubComponents/RightTable/InformasiResultPopup";
import { formatPricewithdecimal } from "../../../../NumberFormat";

const InformasiPopup = (props) => {
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const { onClose, response } = props;
  const [information, setInformation] = useState([]);
  const [selectedTab, setSelectedTab] = useState("Info");
  const handleTabClick = (tabName, e) => {
    // Prevent event propagation to parent elements
    e.stopPropagation();
    setSelectedTab(tabName);

  };
  const InfoComponent = () => {
    return (
      <div className="info_table_tab">
        <table>
          <thead>
            <tr>
              <th>{props.t("bet")}</th>
              <th>{props.t("prize")}</th>
              <th>{props.t("discount")}</th>
              <th>{props.t("min")}</th>
              <th>{props.t("max")}</th>
            </tr>
          </thead>
          <tbody>
            {response.map((item, index) => (
              <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                <td>{item.name !== null ? `${item.name}` : "-"}</td>
                <td>
                  <span className="bluetxt_color">
                    {item.prize !== null ? `${item.prize}` : "-"}
                  </span>
                </td>
                <td>{item.discount !== null ? `${item.discount}` : "-"}</td>
                <td>{item.min !== null ? `${formatPricewithdecimal(item.min)}` : "-"}</td>
                <td>{item.max !== null ? `${formatPricewithdecimal(item.max)}` : "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
  const renderComponent = () => {
    switch (selectedTab) {
      case "Info":
        return <InfoComponent />;
      case "Result":
        return <InformasiResultPopup />;
      default:
        return <InfoComponent />;
    }
  };

  return (
    <div className="overlay">
      <div className="informasi_popup">
        <button className="informasi_popup-close" onClick={onClose}>
          <IoMdClose className="btnclose" />
        </button>
        <div className="result_txt">{props.t("information")}</div>
        <div className="informasi_tble_result infotable">
          {device === "Mobile" ? (<div className="tabs">
            <button
              className={selectedTab === "Info" ? "tab active" : "tab"}
              onClick={(e) => handleTabClick("Info", e)}
            >
              Info
            </button>
            <button
              className={selectedTab === "Result" ? "tab active" : "tab"}
              onClick={(e) => handleTabClick("Result", e)}
            >
              Result
            </button>
          </div>) : ""}
          <div>{renderComponent()}</div>

        </div>
      </div>
    </div >
  );
};

export default withTranslation()(InformasiPopup);
